import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import Calculator from '../components/Calculator.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        const app = createApp({
            template: '<Calculator :programmes="programmes" :activites="activites" :messages="messages" :defaultmessage="defaultmessage" />',
            components: {
                Calculator
            },
            data() {
                return {
                    programmes: [],
                    activites: [],
                    messages: [],
                    defaultmessage: ''
                }
            },
            mounted() {
                fetch('/api/calculateur/data', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    this.programmes = data.programmes
                    this.activites = data.activites
                    this.messages = data.messages
                    this.defaultmessage = data.defaultmessage
                })
            },
        })
        app.mount(self.el)
    }
}
